import {
  $tracksTableSearchInputValue,
  TrackTypeEnum,
  TracksTable,
  TracksTableFiltersMenu,
  TracksTableGate,
  tracksTableQuery,
  tracksTableSearchChanged,
} from '@/entities/tracks'
import { STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { PrimaryButton } from '@/shared/ui'
import { TrackForm } from '@/widgets/TrackForm'
import { trackFormModalOpened } from '@/widgets/TrackForm'
import { FilterOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Button, Flex, Input, Popover, Space } from 'antd'
import { useUnit } from 'effector-react'

import type { AuthorEditorTabProps } from '..'

export const AuthorSermonsTab = ({ author }: AuthorEditorTabProps) => {
  const { data, pending, error } = useUnit(tracksTableQuery)

  const search = useUnit($tracksTableSearchInputValue)
  const changeSearch = useUnit(tracksTableSearchChanged)

  const openFormModal = useUnit(trackFormModalOpened)

  return (
    <>
      <TracksTableGate
        initialFilters={{
          Types: [TrackTypeEnum.Sermon],
          AuthorIds: [author.id],
        }}
      />
      <TrackForm
        isModal
        trackTypes={[TrackTypeEnum.Sermon]}
        initialAuthor={author}
      />
      <Flex justify="end" align="center" style={{ marginBottom: 24 }}>
        <Space>
          <Popover
            content={<TracksTableFiltersMenu />}
            title={STRINGS.label_filters_control}
            trigger="click"
            placement="bottom"
            destroyOnHidden
          >
            <Button icon={<FilterOutlined />}>
              {STRINGS.label_filters_control}
            </Button>
          </Popover>
          <Input
            placeholder={STRINGS.placeholder_search_input}
            allowClear
            addonAfter={<SearchOutlined />}
            value={search || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              const searchQuery = event.target.value
              changeSearch(searchQuery)
            }}
            style={{
              minWidth: 300,
            }}
          />
          <Button
            icon={<PlusOutlined />}
            onClick={() => {
              void openFormModal()
            }}
          >
            Создать
          </Button>
        </Space>
      </Flex>
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <TracksTable
            onEdit={(trackId: string) => void openFormModal({ id: trackId })}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent
            description="В списке пока нет ни одной проповеди"
            content={
              <Space direction="vertical">
                <PrimaryButton
                  onClick={() => {
                    void openFormModal()
                  }}
                >
                  Создать проповедь
                </PrimaryButton>
              </Space>
            }
          />
        )}
      </HidingSpin>
    </>
  )
}
